import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';

// IntersectionObserver should be polyfilled to use this...
class Observer extends Component {
	state = {
		observed: false,
	}

	observerRef = createRef()

	triggerCallback = (entries, observer) => {
		const { once, onObserve } = this.props;
		entries.forEach(entry => {
			if (entry.intersectionRatio <= 0) return;
			if (onObserve) onObserve();
			if (once) observer.unobserve(entry.target);
			this.setState({ observed: true });
		});
	}

	componentDidMount() {
		const { triggerCallback } = this;
		const { threshold } = this.props;
		const config = {
			threshold
		};
		const observer = new IntersectionObserver(triggerCallback, config);
		observer.observe(this.observerRef.current);
	}

	render () {
		const { children } = this.props;
		const passedProps = {
			...this.state,
			observerRef: this.observerRef,
		};
		return children(passedProps);
	}

	static propTypes = {
		children: PropTypes.func.isRequired,
		once: PropTypes.bool,
		onObserve: PropTypes.func,
		threshold: PropTypes.number,
	}

	static defaultProps = {
		threshold: 1,
		once: true,
		onObserve: () => {},
	}
}

export default Observer;
